import InlineStyled from '../InlineStyled/InlineStyled';

const activeTabStyles = {
  color: '#06F',
  fontWeight: 500,
  borderBottom: '1px solid #06F',
};

const AppTabs = ({ tabs = [], activeTab, setActiveTab }) => {
  return (
    <InlineStyled $style={{ display: 'flex', gap: 10 }}>
      {tabs.map((tab) => (
        <InlineStyled
          key={tab.key}
          $style={{
            ...(activeTab === tab.key ? activeTabStyles : {}),
            padding: '8px 16px',
            cursor: 'pointer',
          }}
          onClick={() => {
            setActiveTab(tab.key);
            tab.onClick?.();
          }}
        >
          {tab.label}
        </InlineStyled>
      ))}
    </InlineStyled>
  );
};

export default AppTabs;
